import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const API_URL = 'http://localhost:3000'; // Replace with your backend URL

// Send OTP thunk
export const sendOtpThunk = createAsyncThunk(
  'auth/sendOtp',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/sendOtp`, { params: { email } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Verify OTP thunk
export const verifyOtpThunk = createAsyncThunk(
  'auth/verifyOtp',
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/verifyOtp`, { email, otp });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Register User Thunk
export const registerUserThunk = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/register`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Login User Thunk
export const loginUserThunk = createAsyncThunk(
  'auth/login',
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/login`, loginData);
      const {token} = response.data;
      console.log("Hello!!!");
      console.log(token);
      if(token){
        localStorage.setItem('authToken', token);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Thunk function to handle adding an item to the wishlist
export const addToWishlistThunk = createAsyncThunk(
  'wishlist/addToWishlist',
  async (productId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken'); // Assuming JWT is stored in localStorage
      const response = await axios.post(
        `${API_URL}/addToWishList`,
        { productId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

  // export const logoutThunk = createAsyncThunk(
  //   'auth/logoutThunk',
  //   async (_, { rejectWithValue }) => {
  //     try {
  //       // API call to handle server-side logout (if needed)
  //       await axios.post('/logout');
  //       return true; // Success
  //     } catch (error) {
  //       return rejectWithValue(error.response?.data?.message || 'Logout failed');
  //     }
  //   }
  // );

  export const addProductThunk = createAsyncThunk(
    'products/addProduct',
    async (productData, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          `${API_URL}/addProduct`, JSON.stringify(productData), {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          },
        });
        return response.data.product; // Return the added product
      } catch (error) {
        return rejectWithValue(error.response.data.message);
      }
    }
  );

  export const fetchAllProductsThunk = createAsyncThunk(
    "products/fetchAll",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get(`${API_URL}/api/products`,{
          headers: {
            'Accept': 'application/json', // Only accept JSON responses
            'Content-Type': 'application/json',
          },
        })
        return response.data; // Array of products
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
      }
    }
  );
  // Thunk to delete a product
  export const deleteProductThunk = createAsyncThunk(
    'products/deleteProduct',
    async (productId, { rejectWithValue }) => {
      try {
        console.log(productId);
        const response = await fetch(`${API_URL}/products/${productId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to delete product');
        }
        return productId; // Return the productId for removal in the state
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

// Thunk to edit a product
export const editProductThunk = createAsyncThunk(
  'products/editProduct',
  async (updatedProduct, { rejectWithValue }) => {
    try {
      const productData = {...updatedProduct};
      delete productData._id;
      const response = await fetch(`${API_URL}/products/${updatedProduct._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify(productData),
      });
      if (!response.ok) {
        throw new Error('Failed to edit product');
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeFromWishlistThunk = createAsyncThunk(
  'wishlist/removeFromWishlist',
  async (productId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken'); // Assuming JWT is stored in localStorage
      const response = await axios.delete(
        `${API_URL}/removeFromWishlist`,
        {
          data: { productId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const addAddressThunk = createAsyncThunk(
  "user/addAddress",
  async (address, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.put(
        `${API_URL}/addAddress`,
        { address },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to update an address
export const updateAddressThunk = createAsyncThunk(
  "user/updateAddress",
  async ({ addressIndex, updatedAddress }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.put(
        `${API_URL}/updateAddress`,
        { addressIndex, updatedAddress },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to remove an address
export const removeAddressThunk = createAsyncThunk(
  "user/removeAddress",
  async (addressId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.put(
        `${API_URL}/removeAddress`,
        { addressId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchItemByIdThunk = createAsyncThunk(
  'item/fetchById',
  async (itemId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/products/${itemId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue('Item not found');
    }
  }
);

export const addToCartThunk = createAsyncThunk(
  'cart/addToCart',
  async ({ productId, quantity }, { rejectWithValue }) => {
    try {
      // Send a POST request to add item to the cart
      const response = await axios.put(`${API_URL}/addToCart`,
         { productId, quantity },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        }
      );

      // Return the updated cart data if successful
      return response.data.cart;
    } catch (error) {
      // Return error message if the request fails
      return rejectWithValue(error.response.data.error || 'Failed to add item to cart');
    }
  }
);

export const fetchWishlistThunk = createAsyncThunk(
  "wishlist/fetchWishlist",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/wishlist`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Include JWT token
        },
      });
      return response.data.wishlist;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Failed to fetch wishlist");
    }
  }
);

export const fetchCartItemsThunk = createAsyncThunk(
  "cart/fetchItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/cart`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      return response.data; // Cart items
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Failed to fetch cart items");
    }
  }
);

export const fetchAddressesThunk = createAsyncThunk(
  'cart/fetchAddresses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/fetchAddresses`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      return response.data.addresses;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Server error');
    }
  }
);

export const addOrderThunk = createAsyncThunk(
  'order/addOrder',
  async ({ products,address }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/addOrder`,
        { products,address },
        { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } } // Include token
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchGoogleAuthUrlThunk = createAsyncThunk(
  'auth/fetchGoogleAuthUrl',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/auth/google/url`);
      return response.data.url;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch Google Auth URL');
    }
  }
);

export const handleGoogleCallbackThunk = createAsyncThunk(
  'auth/handleGoogleCallback',
  async (code, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/auth/google/callback`, {
        params: { code },
      });
      return response.data; // User data (token, profile, etc.)
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to authenticate with Google');
    }
  }
);

export const deleteFromCartThunk = createAsyncThunk(
  'cart/deleteFromCart',
  async ({ productId }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/cart/${productId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`, // Assuming token is stored in localStorage
        },
      });
      return response.data.updatedCart; // Return the updated cart
    } catch (error) {
      // Handle errors and pass them to rejectWithValue for proper error handling in Redux
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete/update item in cart'
      );
    }
  }
);

export const searchProductsByNameThunk = createAsyncThunk(
  'products/searchByName',
  async (query, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/searchProductsByName`, {
        params: { query },
      });
      return response.data.products;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const fetchUserThunk = createAsyncThunk(
  'user/fetchUser', 
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken'); // Get token from localStorage or cookies
      const response = await axios.get(`${API_URL}/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // Return user data if successful
    } catch (error) {
      // Use rejectWithValue to send custom error message to the rejected action
      return rejectWithValue(error.response?.data?.error || 'An error occurred');
    }
  }
);

export const fetchProductByIdThunk = createAsyncThunk(
  'products/fetchProductById', // action type
  async (productId, { rejectWithValue }) => {
    try {
      console.log("Product id in thunk: ",productId);
      const response = await axios.post(`${API_URL}/fetchById`,  {productId} );

      if (response.data.success) {
        return response.data.product; // Return the product data on success
      } else {
        return rejectWithValue(response.data.message); // Handle failure
      }
    } catch (error) {
      return rejectWithValue(error.message); // Handle server errors
    }
  }
);

export const forgotPasswordThunk = createAsyncThunk(
  'auth/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/forgot-password`, { email });
      return response.data; // Success message from API
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

export const searchProductsByCategoriesThunk = createAsyncThunk(
  'products/searchByCategories',
  async (categories, { rejectWithValue }) => {
    try {
      // Make the API request with the categories as query parameters
      const response = await axios.get(`${API_URL}/searchProductsByCategories`, {
        params: { categories: categories.join(',') }, // Join the array into a comma-separated string
      });
      return response.data; // Return the response data on success
    } catch (error) {
      // Handle errors and return a rejection with an error message
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch products by categories'
      );
    }
  }
);

export const uploadImageThunk = createAsyncThunk(
  "images/upload",
  async (file, { rejectWithValue }) => {
    console.log("File at upload: ",file);
    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(`${API_URL}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data.imageUrl; // Return the URL of the uploaded image
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to upload image"
      );
    }
  }
);

export const deleteAddressThunk = createAsyncThunk(
  'cart/deleteAddress',
  async (addressId, { rejectWithValue }) => {
    console.log(addressId," sadasd");
    try {
      const response = await axios.put(
        `${API_URL}/removeAddress`,
        { addressId }, // Pass addressId in the request body
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        }
      );
      return response.data.address; // Return updated addresses to update the Redux state
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchOrdersThunk = createAsyncThunk("orders/fetchOrders", async (status = "", { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/orders`, {
      params: { status },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Add token if needed
      },
    });
    console.log("response for Orders: ",response);
    return response.data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || "Failed to fetch orders");
  }
});

export const fetchOrderByIdThunk = createAsyncThunk(
  "orders/fetchById",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Add auth header if needed
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addOrUpdateReviewThunk = createAsyncThunk(
  'reviews/addOrUpdate',
  async ({ productId, comment }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken'); // Adjust based on how tokens are stored
      const response = await axios.post(
        `${API_URL}/addReview/${productId}`,
        { comment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.review;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addOrUpdateRatingThunk = createAsyncThunk(
  'product/addOrUpdateRating',
  async ({ productId, rating }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${API_URL}/rating/${productId}`,
         { rating },
         {headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } });
      return response.data; // This will contain the updated product details including averageRating
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchProductReviewsThunk = createAsyncThunk(
  'product/fetchReviews',
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/fetchReviewsByProductId`, { productId });
      if (response.data.success) {
        return response.data; // Return the reviews and rating info from API
      } else {
        return rejectWithValue(response.data.message); // Handle failure
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateOrderStatusThunk = createAsyncThunk(
  'orders/updateOrderStatus',
  async ({ orderId, status }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/updateOrderStatus`, {
        orderId,
        status,
      });
      return response.data; // Return the updated order data
    } catch (error) {
      // Reject with error message if the API call fails
      return rejectWithValue(error.response?.data || 'Server Error');
    }
  }
);